import * as PIXI from "pixi.js";
import { Signal } from "signals";
import ServiceLocator from "../../ServiceLocator";
import { card_color_type } from "./Card";


export default abstract class SpecialCardAnimation extends PIXI.Container
{
    protected _color: card_color_type = null;

    protected _banner: PIXI.Sprite = null;
    protected _bannerText: PIXI.Text = null;
    protected _glow: PIXI.Sprite = null;

    protected _tl: gsap.core.Timeline = null;

    protected readonly _kArrHexColor: Array<number> = [ 0xff597a, 0xffd21f, 0x30c5ac, 0xa3cb4b ];

    protected _onCompleted: Signal = null;


    public set color( value: card_color_type ) { this._color = value; }

    public get onCompleted(): Signal { return this._onCompleted; }


    protected constructor() { super(); }

    public init(): void
    {
        console.assert( this._color != null, "SpecialCardAnimation.ts :: init() :: this._color cannot be null." );

        this._onCompleted = new Signal();

        this._banner = new PIXI.Sprite( ServiceLocator.resources.tut_header_base.texture );
        this._banner.visible = false;
        this._banner.anchor.set( 0.5 );
        this._banner.position.set( ServiceLocator.app.width * 0.5, 218 );
        this.addChild( this._banner );
        //
        this._bannerText = new PIXI.Text( "", { fontFamily: "asap_bold", fontSize: 80, fill: 0xffffdf } );
        this._bannerText.anchor.set( 0.5 );
        this._banner.addChild( this._bannerText );
        //
        this._banner.visible = false;

        this._glow = new PIXI.Sprite( ServiceLocator.resources.special_glow.texture );
        this._glow.anchor.set( 0.5 );
        this._glow.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._glow );
        //
        this._glow.visible = false;
    }

    public end(): void
    {
        this._onCompleted.dispose();
        this._onCompleted = null;

        if ( this._tl )
        {
            this._tl.kill();
            this._tl = null;
        }
    }

    public abstract play(): void;
}